<template>
  <el-dialog :visible.sync="visible" :modal="false" :show-close="false" top="5vh" append-to-body>
    <div class="container">
      <div class="title">
        <div>扫码关注</div>
        <div>GameKee服务号</div>
      </div>
      <div class="tips">
        <div>互动消息实时推送</div>
      </div>
      <div class="qrcode">
        <img :src="$store.state.serviceQrcodeSrc" alt="服务号二维码" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "ServiceCode",
  props: { value: { type: Boolean, default: false } },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(bool) {
        this.$emit("input", bool);
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  background-image: url("~@/assets/images/miniapp-msg-tips-bg.png");
  background-repeat: no-repeat;
  background-color: transparent;
  width: 188px;
  height: 264px;
  border-radius: 12px;
  padding: 0;
  border: none;
  background-size: 188px 264px;
  box-shadow: none;
}
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 26px;
  .title {
    width: 100%;
    padding-right: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 17px;
    font-weight: 900;
    color: #435f6a;
    text-align: right;
    line-height: 17px;
    margin-bottom: 12px;
  }
  .tips {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    margin-bottom: 10px;
    &::before,
    &::after {
      content: "";
      display: block;
      width: 20px;
      height: 1px;
      background: #dfdfdf;
    }
  }
  .qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
